export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1630608354129-6a7704150401?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1600",
  about: "https://images.unsplash.com/photo-1562408954-be39449c4962?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1400",
  residential: "https://images.unsplash.com/photo-1730807908064-c087959dd52c?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200",
  commercial: "https://images.pexels.com/photos/35454190/pexels-photo-35454190.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  industrial: "https://images.pexels.com/photos/29923348/pexels-photo-29923348.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

// Progetti di esempio (immagini Unsplash "solar panels roof"): sostituisci titoli e località con i tuoi lavori reali
export const PROJECTS = [
  { id: 1, category: "Residenziale", title: "Villa unifamiliare", place: "Bergamo (BG), Italia", img: "https://images.unsplash.com/flagged/photo-1566838616631-f2618f74a6a2?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200" },
  { id: 2, category: "Residenziale", title: "Posa moduli full black", place: "Lugano (TI), Svizzera", img: "https://images.unsplash.com/photo-1624397640148-949b1732bb0a?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200" },
  { id: 3, category: "Commerciale", title: "Copertura edificio terziario", place: "Milano (MI), Italia", img: "https://images.unsplash.com/photo-1724041875334-0a6397111c7e?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200" },
  { id: 4, category: "Industriale", title: "Tetto piano capannone", place: "Zurigo (ZH), Svizzera", img: "https://images.unsplash.com/photo-1613665813446-82a78c468a1d?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200" },
  { id: 5, category: "Residenziale", title: "Casa di nuova costruzione", place: "Verona (VR), Italia", img: "https://images.unsplash.com/photo-1630608354129-6a7704150401?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200" },
  { id: 6, category: "Commerciale", title: "Integrazione in facciata", place: "Bellinzona (TI), Svizzera", img: "https://images.unsplash.com/photo-1724041875467-3576f20170dc?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1200" },
];

export const NAV = [
  { label: "Home", id: "home" },
  { label: "Chi Siamo", id: "chi-siamo" },
  { label: "Soluzioni", id: "soluzioni" },
  { label: "Progetti", id: "progetti" },
  { label: "Contatti", id: "contatti" },
];

// Dati societari e contatti
export const COMPANY = {
  legalName: "Pixa Web sagl",
  address: "Via Cantonale 19, 6900 Lugano, Svizzera",
  vat: "CHE-364.397.948",
  register: "CH-501.4.024.588-7 (Registro di commercio TI)",
  email: "sales@pixasolar.online",
  phone: "+41 78 906 27 64",
  phoneHref: "+41789062764",
  web: "www.pixasolar.online",
  webHref: "https://www.pixasolar.online",
};

export const scrollToId = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
